module.exports = __webpack_public_path__ + "img/icon_favs_blue.9568364.svg";